module.exports = __webpack_public_path__ + "img/hys-5.6fc825d6.webp";